import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getProfileOwnerStats } from '../../../selectors/users';

export default connect((state: AppState) => ({
  stats: getProfileOwnerStats(state),
}));
